import AboutUs from "./pages/aboutUs/AboutUs";
import ContactUs from "./pages/contactUs/ContactUs";
import Discounts from "./pages/discounts/Discounts";
import Home from "./pages/home/Home";
import NotFound from "./pages/notFound/NotFound";
import ProtocolDetails from "./pages/protocolDetails/ProtocolDetails";
import Protocols from "./pages/protocols/Protocols";
import Products from "./pages/products/Products";
import Inventory from "./pages/inventory/Inventory";  // this page appears when user searchs a product or clicks on one of marqueeBanner brands and the content is all inventories of that brand regardless of category.

import { useParams } from "react-router-dom";
import SearchResults from "./pages/searchResults/SearchResults";
import OurServices from "./pages/ourServices/OurServices";

function ProductsWrapper() {
  const { slug } = useParams();
  return <Products key={slug} />;
}

const routes = [
  {path: '/', index: true, element: <Home />},
  {path: '/aboutUs', element: <AboutUs />},
  {path: '/contactUs', element: <ContactUs />},
  {path: '/discounts', element: <Discounts />},
  {path: '/protocols', element: <Protocols />},
  {path: '/protocols/:slug', element: <ProtocolDetails />},
  {path: '/inventory/:slug', element: <Inventory />},
  {path: '/products/:slug', element: <ProductsWrapper />},
  {path: '/search', element: <SearchResults />},
  // {path: '/services', element: <OurServices />},
  {path: '*', element: <NotFound />},
];

export default routes;